import { useState, useEffect, useCallback } from "react";
import { CognitoAuthService } from "../../../services/cognitoService";
import { debug, formatSafeErrorMessage } from "../../../utils/debugLogger";

const useMfaStatus = () => {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [refetchTrigger, setRefetchTrigger] = useState(0);

  const refetch = useCallback(() => setRefetchTrigger((t) => t + 1), []);

  useEffect(() => {
    let isMounted = true;

    const fetchStatus = async () => {
      if (isMounted) {
        setLoading(true);
        setError(null);
      }
      try {
        const isEnabled = await CognitoAuthService.getMfaStatus();
        if (isMounted) setEnabled(isEnabled);
      } catch (err: any) {
        debug.error("Failed to load MFA status:", formatSafeErrorMessage(err));
        if (isMounted) {
          setError(err.message || "Failed to load two-factor authentication status");
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchStatus();

    return () => {
      isMounted = false;
    };
  }, [refetchTrigger]);

  return { enabled, loading, error, refetch };
};

export default useMfaStatus;
